<mat-card class="mat-mdc-card mdc-card cardWithShadow card2 position-relative card-hover">
    <mat-card-content class="mat-mdc-card-content p-y-24">
        <div class="row d-flex justify-content-between">
            <div class="col-md-12 divDownload">
                <button mat-mini-fab class="excel" (click)="DownLoadNumberOfUsersExcelReport()">
                    <i-tabler name="file-type-xls" class="routeIcon"></i-tabler>
                </button>

                <button mat-mini-fab class="pdf" (click)="DownLoadNumberOfUsersPDFReport()">
                    <i-tabler name="file-type-pdf" class="routeIcon"></i-tabler>
                </button>
            </div>
        </div>
        <div class='content'>
            <table>
                <thead>
                    <tr>
                        <th>{{'UserType'|translate}}</th>
                        <th>{{'Count'|translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of usersCount">
                        <td>{{user.userTypeName|translate}}</td>
                        <td>{{user.count}}</td>
                    </tr>

                    <tr *ngIf="usersCount.length==0">
                        <td colspan="2">{{ 'NoDataFound' | translate }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </mat-card-content>
</mat-card>